<template>
  <div class="d-flex flex-column mx-2">
    <div class="d-flex align-center mb-4 justify-space-between">
      <div class="d-flex ">
        <span
          :class="isValid || isOpen ? 'secondary' : 'background-inactif'"
          class="index white--text mention mx-2"
        >
          {{ stepIndex }}
        </span>
        <span
          :class="isValid || isOpen ? 'secondary--text' : 'texte-inactif'"
          class="titre-h4 mx-2"
        >
          {{ titre }}
        </span>
      </div>
      <div class="d-flex mr-3">
        <v-icon
          v-if="!isEditDisabled"
          @click="onEdit"
        >
          mdi-pencil
        </v-icon>
      </div>
    </div>
    <div>
      <slot name="stepContent" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseStep',
  props: {
    stepIndex: {
      type: Number,
      required: true
    },
    titre: {
      type: String,
      required: true
    },
    isEditDisabled: {
      type: Boolean,
      default: true
    },
    isOpen: {
      type: Boolean,
      required: true
    },
    isValid: {
      type: Boolean,
      required: true
    },
  },

  methods: {
    onEdit () {
      this.$emit('edit')
    }
  }
}
</script>

<style lang="scss" scoped>
.index {
  border-radius: 24px;
  width: 20px;
  height: 20px;
}
</style>
